import React, { useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { DeleteBusiness, GetAllBusiness } from '../../store/actions/new/businessAction';
import { ShimmerCategoryItem } from 'react-shimmer-effects';
import SearchForm from '../default/search/searchForm';
import NoContentFound from '../default/not-found/notFound';
import AddNewBusinessPopup from './popup/addNewPopup';
import { ADD_NEW_BUSINESS_ITEM } from '../../store/constants/businessConstant';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import ShimmerImage from '../default/popup/shimmerImage/shimmerImage';
import { InitialAvatar } from '../default/utils/defaultAvatar';

const BusinessList = () => {
    const [openDropdown, setOpenDropdown] = useState(null);
    const [openPopup, setPopup] = useState(false);
    const [hasLoaded, setHasLoaded] = useState(false);

    const toggleDropdown = (index) => {
        setOpenDropdown(prevIndex => (prevIndex === index ? null : index));
    };
    const navigate = useNavigate();
    const handleSinglePage = (id) => {
        navigate(`/business/${id}`);
    }
    //out side click for dropdown
    const handleOutsideClick = (event) => {
        if (event.target.closest('.list-edit-dropdown') === null) {
            setOpenDropdown(null);
        }
    };
    const handlePopup = () => {
        setPopup(true);
    }
    const [pageCount, setPageCount] = useState(1);
    const [loading, setLoading] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const prevSearchTermRef = useRef();

    //store data
    const allData = useSelector((state) => state.businessAllData);
    const { businessData, error, isLoading } = allData;
    const { data, pagination } = businessData;

    const dispatch = useDispatch();
    const searchCards = async () => {
        if (!hasLoaded) return;
        setLoading(true);
        let postData = {
            page: 1,
            keyword: searchTerm
        }
        await dispatch(GetAllBusiness(postData));
        setLoading(false);
    }
    const loadMore = () => {
        const nextPage = pagination.page + 1;
        if (nextPage <= pagination.page_last) {
            setPageCount(nextPage);
            let postData = {
                page: nextPage,
                keyword: searchTerm
            }
            dispatch(GetAllBusiness(postData));
        }
    };
    React.useEffect(() => {
        if (!hasLoaded) {
            // Check if store already has data
            if (!businessData || !businessData.data || businessData.data.length === 0) {
                let postData = {
                    page: 1,
                    keyword: ''
                }
                dispatch(GetAllBusiness(postData));
            }
            setHasLoaded(true);
        }
        if (prevSearchTermRef.current !== searchTerm) {
            searchCards();
        }
        prevSearchTermRef.current = searchTerm;

        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [data, dispatch, searchTerm]);

    // Add new business 
    const handleAddNewBusiness = (itemRes) => {
        if (itemRes.status >= 200) {
            dispatch({
                type: ADD_NEW_BUSINESS_ITEM,
                payload: {
                    data: itemRes.data
                }
            });
        }
    }
    //remove connection item
    const MySwal = withReactContent(Swal)
    const handleDeleteBusiness = (id) => {
        MySwal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#ccc",
            confirmButtonText: "Conform",
            didOpen: () => {
                document.body.style.overflow = "hidden";
            },
            willClose: () => {
                document.body.style.overflow = "";
            }
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(DeleteBusiness(id));

            }
        });

    }

    return (
        <div className="card-container card-list-area">
            <div className="connection-header">
                <h3>Business Lists</h3>
                <div className="filter-wrapper">
                    <SearchForm
                        placeholder='Search card...'
                        loading={loading}
                        onChange={async (val) => {
                            setSearchTerm(val);
                        }}

                    />
                    <div className="list-filter">
                        <i className="ri-equalizer-line"></i>
                        <span>Filter</span>
                    </div>
                    <div className="list-filter add-new-btn" onClick={handlePopup}>
                        <i className="ri-add-line"></i>
                        <span>Add New</span>
                    </div>
                </div>
            </div>
            {error && error.message}
            <div className="more-pck-wrapper business-list">
                {data && data.map((item, index) => (
                    <div className="mr-single-package" key={item.id}>
                        <div className="mrp-details" onClick={() => { handleSinglePage(item.id) }}>
                            {item.feature_photo_url ? (
                                <ShimmerImage
                                    src={item.feature_photo_url}
                                    alt={item.name}
                                    width={65}
                                />
                            ) : (
                                <InitialAvatar
                                    title={`${item.name}`}
                                    size={65}
                                />
                            )}
                            <div className="package-info">
                                <h4>{item.name}</h4>
                                <span>{item.tagline ? item.tagline :
                                    (item.description ?
                                        item.description.split(' ').slice(0, 15).join(' ') +
                                        (item.description.split(' ').length > 15 ? '...' : '')
                                        : ''
                                    )
                                }
                                </span>
                            </div>
                        </div>
                        <div className="list-edit-dropdown">
                            <i
                                className="ri-more-2-fill"
                                onClick={() => toggleDropdown(index)}
                            ></i>
                            {openDropdown === index && (
                                <ul>
                                    <li><Link onClick={() => {
                                        handleDeleteBusiness(item.id);
                                        setOpenDropdown(null)
                                    }}>Delete</Link></li>
                                </ul>
                            )}
                        </div>
                    </div>
                ))}
                {!isLoading && !data &&
                    <NoContentFound title="No Business found!" />
                }
                {isLoading &&
                    <div className='shimmer-white'>
                        <ShimmerCategoryItem
                            hasImage
                            imageType="circular"
                            imageWidth={50}
                            imageHeight={50}
                            categoryStyle="STYLE_SEVEN"
                            text
                        />
                        <ShimmerCategoryItem
                            hasImage
                            imageType="circular"
                            imageWidth={50}
                            imageHeight={50}
                            className="shimmer-white-bg"
                            text
                        />
                    </div>
                }
                {!isLoading && data && pagination.page_last > pagination.page && (
                    <div className="load-more-container">
                        <button
                            className="load-more-btn"
                            onClick={loadMore}
                            disabled={isLoading}
                        >
                            {isLoading ? 'Loading...' : 'Load More'}
                        </button>
                    </div>
                )}
            </div>

            <AddNewBusinessPopup openModal={openPopup} setOpen={setPopup} type="Business" onSubmitResponse={handleAddNewBusiness} />
        </div>
    );
}

export default BusinessList;
